import styled from '@emotion/styled';
import CircledButton from 'common/components/buttons/CircledButton';
import SvgRender from 'common/components/general/SvgRender';
import list from 'common/assets/svg/common/burger.svg';
import PropTypes from 'prop-types';

const AddNewContainer = ({ formIsVisible, onClick }) => {
  return (
    <Container className="d-flex align-items-center justify-content-center py-20 px-3 position-relative rounded">
      <SvgRender
        className="text-light-gray-2 position-absolute ms-n15"
        src={list}
        style={{ width: 60, height: 60 }}
      />
      <CircledButton
        type="add"
        className="position-relative"
        disabled={formIsVisible}
        label={<span className="fs-14">Add menu</span>}
        onClick={onClick}
      />
    </Container>
  );
};

const Container = styled.div`
  background-clip: padding-box;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23CACACA' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
`;

AddNewContainer.propTypes = {
  formIsVisible: PropTypes.bool,
  onClick: PropTypes.func
};

export default AddNewContainer;
